import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { cesAuthOptions } from '@cheetahdigital/cesauth-core-lib';
import { createContext, useState, useCallback, useEffect, useContext } from 'react';
import ChangeBusinessUnitModal from '../Navbar/MyAccount/ChangeBusinessunitModal/index.js';
import { useOrganizationContext } from './OrganizationProvider.js';

var changeBusinessUnitModalContext = createContext(null);
var ChangeBusinessUnitModalProvider = function (_a) {
    var children = _a.children;
    var context = useState(false);
    var isShowChangeBusinessUnitModal = context[0], setIsShowChangeBusinessUnitModal = context[1];
    var _b = useOrganizationContext().organizations, organizations = _b === void 0 ? [] : _b;
    var handleAddModalShortcutKey = useCallback(function () {
        var handleKeyDown = function (event) {
            if ((event.metaKey || event.ctrlKey) && event.key === "b") {
                setIsShowChangeBusinessUnitModal(function (isShow) { return !isShow; });
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return function () {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [setIsShowChangeBusinessUnitModal]);
    useEffect(function () {
        if (organizations.length > 1) {
            handleAddModalShortcutKey();
        }
    }, [handleAddModalShortcutKey, organizations.length]);
    return (jsxs(changeBusinessUnitModalContext.Provider, __assign({ value: context }, { children: [children, jsx(ChangeBusinessUnitModal, { isActive: isShowChangeBusinessUnitModal, onClose: function () { return setIsShowChangeBusinessUnitModal(false); } }, void 0)] }), void 0));
};
var useChangeBusinessUnitModalContext = function () {
    var context = useContext(changeBusinessUnitModalContext);
    if (!context) {
        throw new Error("useChangeBusinessUnitModalContext must be used within a ChangeBusinessUnitModalProvider");
    }
    return context;
};
var getChangeBusinessUnitRedirectUrl = function (_a) {
    var platformId = _a.platformId, buId = _a.buId;
    return "".concat(cesAuthOptions.authBaseURL, "/businessUnit/switch?redirect_url=").concat(encodeURIComponent(window.location.href)).concat(cesAuthOptions.isLoginAs ? "&is_login_as=true" : "", "&platform=").concat(platformId, "&business_unit_id=").concat(buId);
};

export { ChangeBusinessUnitModalProvider as default, getChangeBusinessUnitRedirectUrl, useChangeBusinessUnitModalContext };
